import { useState, useEffect } from "react";
import { atualizarReservaStatusService } from "../services/atualizarReservaStatusService";

export const useAtualizarReservaStatus = (
  reservaId: number | null,
  status: string
) => {
  const [reservaStatusAtualizado, setReservaStatusAtualizado] = useState<
    boolean | null
  >(null);

  const [isLoading, setIsLoading] = useState(true);
  const [success, setSuccess] = useState<string>();
  const [error, setError] = useState<string>();

  useEffect(() => {
    const atualizarStatusReserva = async () => {
      if (reservaId !== null && status !== "") {
        setIsLoading(true);
        try {
          const data = await atualizarReservaStatusService(reservaId, status);
          if (data) {
            setReservaStatusAtualizado(true);
            setSuccess("Status atualizado com sucesso!");
          } else {
            setReservaStatusAtualizado(false);
            setError(`Não foi possível atualizar o status!`);
          }
        } catch (err) {
          console.error(err);
          setError("Erro ao atualizar o status!");
        } finally {
          setIsLoading(false);
        }
      }
    };

    atualizarStatusReserva();
  }, [reservaId, status]);

  return {
    reservaStatusAtualizado,
    isLoading,
    success,
    error,
  };
};
